import { FormBuilder } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { IdentificationService } from "@api/identification.service";
import { ActivatedRoute } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { environment } from "environments/environment";
import { ConnectIdentificationService } from "@shared/services/connect-identification.service";
import jalaliMoment = require("jalali-moment");

@Component({
  selector: "app-identification-info",
  templateUrl: "./identification-info.component.html",
  styleUrls: ["./identification-info.component.scss"],
})
export class IdentificationInfoComponent implements OnInit {

  baseUrl = environment.baseUrl;
  airlicenseExpiryDate;
  clearanceCommunityLicenseExpiryDate;
  communityLicenseExpiryDate;
  landlicenseExpiryDate;
  raillicenseExpiryDate;
  sealicenseExpiryDate;
  transitCertExpiryDate;
  public destroy$ = new Subject<void>();
  identificationInfoForm: FormGroup;
  identificationInfo: any;
  provider: any;
  id: any;
  constructor(
    private formBuilder: FormBuilder,
    private identificationService: IdentificationService,
    private route: ActivatedRoute,
    private connectIdentificationService: ConnectIdentificationService,
  ) { }

  ngOnInit(): void {
    this.getInitionalIdentificationForm();
    this.id = this.route.snapshot.paramMap.get("id");
    this.identificationService
      .getIdentificationById(this.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.identificationInfo = res;
        if (this.identificationInfo?.airlicenseExpiryDate?.value) {
          this.airlicenseExpiryDate = jalaliMoment(this.identificationInfo?.airlicenseExpiryDate?.value).format('jYYYY/jMM/jDD hh:mm');
        } else {
          this.airlicenseExpiryDate = ''
        }
        if (this.identificationInfo?.clearanceCommunityLicenseExpiryDate?.value) {
          this.clearanceCommunityLicenseExpiryDate = jalaliMoment(this.identificationInfo?.clearanceCommunityLicenseExpiryDate?.value).format('jYYYY/jMM/jDD hh:mm');
        } else {
          this.clearanceCommunityLicenseExpiryDate = ''
        }
        if (this.identificationInfo?.communityLicenseExpiryDate?.value) {
          this.communityLicenseExpiryDate = jalaliMoment(this.identificationInfo?.communityLicenseExpiryDate?.value).format('jYYYY/jMM/jDD hh:mm');
        } else {
          this.communityLicenseExpiryDate = ''
        }
        if (this.identificationInfo?.landlicenseExpiryDate?.value) {
          this.landlicenseExpiryDate = jalaliMoment(this.identificationInfo?.landlicenseExpiryDate?.value).format('jYYYY/jMM/jDD hh:mm');
        } else {
          this.landlicenseExpiryDate = ''
        }
        if (this.identificationInfo?.raillicenseExpiryDate?.value) {
          this.raillicenseExpiryDate = jalaliMoment(this.identificationInfo?.raillicenseExpiryDate?.value).format('jYYYY/jMM/jDD hh:mm');
        } else {
          this.raillicenseExpiryDate = ''
        }
        if (this.identificationInfo?.sealicenseExpiryDate?.value) {
          this.sealicenseExpiryDate = jalaliMoment(this.identificationInfo?.sealicenseExpiryDate?.value).format('jYYYY/jMM/jDD hh:mm');
        } else {
          this.sealicenseExpiryDate = ''
        }
        if (this.identificationInfo?.transitCertExpiryDate?.value) {
          this.transitCertExpiryDate = jalaliMoment(this.identificationInfo?.transitCertExpiryDate?.value).format('jYYYY/jMM/jDD hh:mm');
        } else {
          this.sealicenseExpiryDate = ''
        }
        this.getVerificationPatchValue();
      });
    this.connectIdentificationService
      .getItem()
      .pipe()
      .subscribe((value) => {
        if (value) {
          this.provider = JSON.parse(JSON.stringify(value));
        }
      });
  }
  getInitionalIdentificationForm() {
    this.identificationInfoForm = this.formBuilder.group({
      economicCode: [null, []],
      nationalCode: [null, []],
      nationalCodeImage: [null, []],
      registrationNumber: [null, []],
      companyNationalCode: [null, []],
      clearanceCommunityLicenseNumber: [null, []],
      clearanceCommunitylicenseImage: [null, []],
      clearanceCommunityLicenseExpiryDate: [null, []],
      communityLicenseNumber: [null, []],
      communitylicenseImage: [null, []],
      communityLicenseExpiryDate: [null, []],
      officialNewspaperImage: [null, []],
      companyLetterheadImage: [null, []],
      companyProfileImage: [null, []],
      landlicenseImage: [null, []],
      airlicenseImage: [null, []],
      raillicenseImage: [null, []],
      sealicenseImage: [null, []],
      landlicenseNumber: [null, []],
      airlicenseNumber: [null, []],
      raillicenseNumber: [null, []],
      sealicenseNumber: [null, []],
      landlicenseExpiryDate: [null, []],
      airlicenseExpiryDate: [null, []],
      raillicenseExpiryDate: [null, []],
      sealicenseExpiryDate: [null, []],
      transitCertExpiryDate: [null, []],
      transitCertNumber: [null, []],
      transitImage: [null, []],
    });
  }
  saveIdentification() {
    this.identificationService.postIdentificationById(this.id, this.identificationInfoForm.value)
      .subscribe((res) => { });
  }
  getVerificationPatchValue() {
    this.identificationInfoForm.patchValue(this.identificationInfo.value);
  }
}
